/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useCallback } from 'react';
import classNames from 'classnames';
import Locale from '@active/react-utils/i18n/Locale';
import useLocale from '@active/react-utils/i18n/useLocale';
import { useSelector, useDispatch } from 'react-redux';
import Radio from '@active/react-ui/Radio';
import RadioGroup from '@active/react-ui/RadioGroup';
import * as typeConfigs from './config';
import { setCurrentActivePaymentMethod } from '../../paymentMethodsSlice';

const PaymentMethodSwitch = () => {
  const dispatch = useDispatch();
  const { currentActivePaymentMethod, supportTypes } = useSelector(state => state.paymentMethods);
  const { i18n } = useLocale();
  const handleClick = useCallback((e) => {
    dispatch(setCurrentActivePaymentMethod(e.target.value));
  }, [ dispatch ]);

  return (
    <div className="payment-switch cui-mg-t-20">
      <RadioGroup
        aria-label={i18n('checkout.lib.components.payment.paymentMethod.selectOnePaymentMethod')}
        value={currentActivePaymentMethod}
        onChange={handleClick}>
        <div className='payment-switch-group'>
          {supportTypes.filter((paymentMethodType) => {
            return typeConfigs[paymentMethodType].active;
          }).map((paymentMethodType) => {
            const {
              icon, text,
            } = typeConfigs[paymentMethodType];
            return (
              <Radio
                key={paymentMethodType}
                value={paymentMethodType}
                aria-hidden="false"
                className={classNames('payment-switch__item', {
                  active: paymentMethodType === currentActivePaymentMethod,
                })}
                aria-label={i18n(text)}
                role="radio"
                tabIndex={paymentMethodType === currentActivePaymentMethod ? 0 : -1}
                aria-checked={paymentMethodType === currentActivePaymentMethod}>
                <span className={classNames(icon, 'payment-switch__item__icon')}></span>
                <div className="payment-switch__item__text">
                  <Locale id={text} />
                </div>
              </Radio>
            );
          })}
        </div>
      </RadioGroup>
    </div>
  );
};

export default PaymentMethodSwitch;
